import React, { useRef, useEffect } from 'react';
import GuessRow from './GuessRow';
import '../styles/GameBoard.css';

function GameBoard({ guessResults }) {
  const prevCountRef = useRef(guessResults.length);
  
  // Check if exactly one row was added (new guess vs bulk load)
  const isNewGuess = guessResults.length === prevCountRef.current + 1;
  
  // Update ref AFTER render completes
  useEffect(() => {
    prevCountRef.current = guessResults.length;
  }, [guessResults.length]);

  return (
    <div className="guesses-container">
      <div className="header-row">
        <div className="header-cell">SKYLANDER</div>
        <div className="header-cell">GAME</div>
        <div className="header-cell">ELEMENT</div>
        <div className="header-cell">SPEED</div>
        <div className="header-cell">HEALTH</div>
        <div className="header-cell">ARMOR</div>
        <div className="header-cell">GENDER</div>
        <div className="header-cell">COLOR</div>
      </div>
      
      {guessResults.map((guessData, index) => (
        <GuessRow
          key={index}
          guess={guessData.skylander}
          results={guessData.results}
          isNew={index === guessResults.length - 1 && isNewGuess}
        />
      ))}
    </div>
  );
}

export default GameBoard;
